import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.content) {
    errors.content = true;
  }

  return errors;
};

class ParagraphForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.goBack = () => context.router.goBack();
  }

  render() {
    const { fields: { content }, handleSubmit, submitting } = this.props;

    return (
      <form className="ui form" onSubmit={handleSubmit}>
        <div className="ui top attached segment">
          <div className={fieldClass(content)}>
            <label>Nom</label>
            <textarea name="content" placeholder="Contenu" {...content} />
          </div>
        </div>
        <div className="ui bottom attached clearing segment">
          <button
            className="ui right floated primary button"
            type="submit"
            disabled={submitting}
          >
            Valider
          </button>
          <button className="ui right floated button" onClick={this.goBack}>
            Annuler
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm(
  {
    form: 'paragraph',
    fields: ['content'],
    validate,
  },
  (state, ownProps) => {
    const { id } = ownProps;
    return {
      initialValues: state.tips.chapters.paragraphs.get(id),
    };
  }
)(ParagraphForm);



// WEBPACK FOOTER //
// ./src/modules/tip/components/ParagraphForm.js